<!--<p>frequent-question works!</p>-->

<div
  class="bg-custom-bg-gray-3 hover:shadow-md p-6 rounded-lg transition-colors duration-200 hover:bg-gray-100"
>
  <button
    (click)="toggle()"
    class="flex justify-between items-center w-full text-left"
  >
    <span class="text-lg font-medium text-custom-black font-rubik">
      {{ index + 1 }}. {{ question.question }}
    </span>
    <svg
      [class.rotate-180]="faqOpen"
      class="w-5 h-5 text-custom-red transition-transform duration-200"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 9l-7 7-7-7"
      />
    </svg>
  </button>

  <div
    [class.hidden]="!faqOpen"
    class="mt-3 font-rubik text-custom-black-2 leading-relaxed"
  >
    {{ question.answer }}
  </div>
</div>
